import {eventNameConst, stateConst} from '../conf';
import {attrCore, nodeCore} from '../core/logic';


/**
 * 拓扑插件-节点相关事件
 */


/**
 * 拓扑插件-节点-初始化节点相关事件
 * @param that vue实例
 */
export function initNodeEvent(that) {
  const stage = that.getCanvasStage();

  stage.on(eventNameConst.nodeEvent.mouseDown, _ => {

    // 清除弹窗详情
    that.$bus.$emit('custom:node:info:showDetail', false);
  });


  // 监听鼠标进入节点
  stage.on(eventNameConst.nodeEvent.mouseEnter, evt => {
    const nodeItem = evt.item;

    // 删除附加的样式属性
    nodeCore.handleDeleteStateStyle(nodeItem);
    // 设置目标节点的 hover 状态 为 true
    stage.setItemState(nodeItem, stateConst.active, true);
  });


  // 监听鼠标悬停节点
  stage.on(eventNameConst.nodeEvent.mouseOver, evt => {
    const nodeItem = evt.item;
    // const point = stage.getPointByClient(evt.clientX, evt.clientY);
    // const clientPoint = stage.getClientByPoint(nodeItem.getModel().x, nodeItem.getModel().y);
    // console.log(JSON.stringify(clientPoint), '页面转换坐标', evt);
    // const canvasPoint = stage.getCanvasByPoint(nodeItem.getModel().x, nodeItem.getModel().y);
    // console.log(nodeItem, '悬停', nodeItem.getModel().x, nodeItem.getModel().y, '转换', clientPoint, canvasPoint);

    // 非连线模式
    if (!that.tpOptions.joinLineActive) {
      that.$bus.$emit('custom:node:info:showDetail', true, nodeItem, {x: evt.clientX, y: evt.clientY});
    }
  });


  // 监听鼠标离开节点
  stage.on(eventNameConst.nodeEvent.mouseLeave, evt => {
    const nodeItem = evt.item;
    // 设置目标节点的 hover 状态 false
    stage.setItemState(nodeItem, stateConst.active, false);

    // 非连线模式
    if (!that.tpOptions.joinLineActive) {
      that.$bus.$emit('custom:node:info:showDetail', false);
    }
  });


  // 监听鼠标点击节点
  stage.on(eventNameConst.nodeEvent.click, evt => {
    const item = evt.item;

    console.log('节点单击', evt, item, item.getType(), item.getModel());
  });


  // 监听节点选中状态改变事件
  stage.on(eventNameConst.timingEventName.nodeSelectChange, evt => {

    // 如果属性栏显示，则触发属性赋值
    if (that.tpOptions.showAttribute) {
      attrCore.triggerShapeAttributeTabActive(that);
    }
  });
}
